import ProductCard from "@/components/productCard/ProductCard";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useEffect, useState } from "react";

const ViewedProductSlider = ({ products = [] }) => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(1);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    const handleSelect = () => {
      setCurrent(api.selectedScrollSnap() + 1);
    };
    api.on("select", handleSelect);

    return () => {
      api.off("select", handleSelect);
    };
  }, [api]);

  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  return (
    <Carousel opts={{ align: "start" }} className="w-full pb-6" setApi={setApi}>
      <CarouselContent className="m-0">
        {products?.length > 0 &&
          products.map((productList, index) => (
            <CarouselItem
              key={index}
              className="basis-1/4 m-0 mlg:basis-1/3 viewedCard820:basis-1/2 viewedCard570:basis-full"
            >
              <div className="px-2 py-[10px] h-full">
                <ProductCard
                  className="border-2 h-full min-h-[520px] mxl:py-[22px] lg:min-h-[453px]  mxl:min-h-[480px] flex flex-col justify-between rounded-2xl border-gray5 px-[15px] pt-9 pb-[30px]"
                  productDetail={productList}
                  index={index}
                  type="short"
                />
              </div>
            </CarouselItem>
          ))}
      </CarouselContent>
      <div className=" grid grid-cols-3 lg:grid-cols-[1fr_auto] items-center gap-3 lg:pl-2">
        <div className=" lg:hidden"></div>
        {/* Clickable Pagination Dots */}
        <div className="flex justify-center ">
          {Array.from({ length: count }).map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-full h-1  transition-all ${
                current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
              }`}
            />
          ))}
        </div>
        {/* Navigation Buttons */}
        <div className="flex items-center justify-end gap-3">
          <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
          <div className="text-sm text-[#0C2340] font-medium">
            {current}/{count}
          </div>
          <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
        </div>
      </div>
    </Carousel>
  );
};

export default ViewedProductSlider;
